import personalizedPromotions from 'reducers/personalizedPromotions';
const { ACTION_TYPES: TYPES } = personalizedPromotions;
import ProfileApi from 'services/api/profile';
import UserUtils from 'utils/User';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import CacheUtils from 'utils/Cache';
const DEFAULT_EXPIRY = Storage.MINUTES * 60;
const DELAY = Storage.MINUTES * 5;
const PST_OFFSET = 8;
import localeUtils from 'utils/LanguageLocale';
const { isTestTargetReadySelector } = require('viewModel/selectors/testTarget/isTestTargetReadySelector');

const updatePersonalizedPromotions = data => ({
    type: TYPES.UPDATE_PERSONALIZED_PROMOTIONS,
    data: data
});

const createEmptyPayload = profileId => ({
    profileId: profileId,
    items: [],
    loading: false
});

const { isBeautyOffersEnabled } = Sephora.configurationSettings;

const loadPersonalizedPromotions = showSephoraMLModelV2Promos => (dispatch, getState) => {
    const {
        user,
        user: { profileId }
    } = getState();

    const reduxState = getState();
    const isTestTargetReady = isTestTargetReadySelector(reduxState);

    const payload = createEmptyPayload();
    payload.loading = true;
    dispatch(updatePersonalizedPromotions(payload));

    let cachedPromotions = null;

    if (showSephoraMLModelV2Promos) {
        cachedPromotions = Storage.local.getItem(LOCAL_STORAGE.PERSONALIZED_PROMOTIONS_V2, false, true);
    } else {
        cachedPromotions = Storage.local.getItem(LOCAL_STORAGE.PERSONALIZED_PROMOTIONS, false, true);
    }

    const isUS = localeUtils.isUS();

    if (UserUtils.isAnonymous(user)) {
        dispatch(updatePersonalizedPromotions(createEmptyPayload()));
    } else if (cachedPromotions && cachedPromotions.profileId === profileId) {
        dispatch(updatePersonalizedPromotions(cachedPromotions));
    } else {
        isTestTargetReady &&
            ProfileApi.getPersonalizedPromotions(profileId, isUS, showSephoraMLModelV2Promos)
                .then(data => {
                    const showPromos = isBeautyOffersEnabled && isUS;
                    const freshData = {
                        profileId,
                        items: showPromos ? data.allPromos.slice(0, 5) : data.personalizedPromotions || [],
                        loading: false,
                        hasNewPersonalizedPromotions: false
                    };
                    const userData = Storage.local.getItem(LOCAL_STORAGE.USER_DATA, false, false, true);

                    if (userData?.data?.personalizedPromotions?.hasNewPersonalizedPromotions) {
                        userData.data.personalizedPromotions.hasNewPersonalizedPromotions = false;
                        Storage.local.setItem(LOCAL_STORAGE.USER_DATA, userData.data, userData.expiry);
                    }

                    const expiry = CacheUtils.getLessOfTillMidnightOrDefault(DEFAULT_EXPIRY, DELAY, PST_OFFSET);

                    if (showSephoraMLModelV2Promos) {
                        Storage.local.setItem(LOCAL_STORAGE.PERSONALIZED_PROMOTIONS_V2, freshData, expiry);
                    } else {
                        Storage.local.setItem(LOCAL_STORAGE.PERSONALIZED_PROMOTIONS, freshData, expiry);
                    }

                    dispatch(updatePersonalizedPromotions(freshData));
                })
                .catch(error => {
                    // eslint-disable-next-line no-console
                    console.error(error);
                    dispatch(updatePersonalizedPromotions(createEmptyPayload(profileId)));
                });
    }
};

export default {
    TYPES,
    loadPersonalizedPromotions,
    updatePersonalizedPromotions
};
